import React, { useEffect } from 'react';
import { makeStyles } from 'design-system';
import InstructionHeader from './components/header';
import SideNavigation from './components/sideNavigation';
import Details from './components/details';
import SearchPage from './components/searchPage';
import Banner from './components/banner';
import { useProjectInstructionContext } from './projectInstructionContext';
import { NormalizedComponentProps } from './types';
import { getEachSubComponentDataFromId } from 'react-scale/components/scalers/instruction/utils';

const Instruction = () => {
  const {
    components,
    setSelectedPath,
    selectedSection,
    isRapidPreview,
    searchResult,
    isEmbedded,
    doNotRenderChildrenSet,
  } = useProjectInstructionContext();

  const classes = useStyles();

  const handleHashChange = () => {
    const anchorTag = decodeURI(window.location.hash.substring(1));
    if (components) {
      for (const comp of components) {
        if (comp.nodeName === anchorTag) {
          setSelectedPath([comp.nodeType, comp.nodeId]);
          break;
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener('hashchange', handleHashChange);
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [components]);

  return (
    <div className={classes.background}>
      <div className={classes.containerScalers}>
        {!isRapidPreview && <InstructionHeader />}
        {isEmbedded && <Banner />}
        <div className={classes.contentWrapper}>
          <SideNavigation />
          {isRapidPreview ? (
            <div className={classes.verticalWrapper}>
              {components.map((c: NormalizedComponentProps, index: number) => {
                if (c.content?._id && !doNotRenderChildrenSet?.has(c.content?._id)) {
                  return (
                    <Details
                      key={index}
                      contentData={c.content}
                      index={index}
                      subAttributeContentData={
                        c.content?.nestedAttributeIds
                          ? getEachSubComponentDataFromId(components, c.content?.nestedAttributeIds)
                          : []
                      }
                      subLabelContentData={
                        c.content?.nestedLabelIds
                          ? getEachSubComponentDataFromId(components, c.content?.nestedLabelIds)
                          : []
                      }
                    />
                  );
                }
              })}
            </div>
          ) : (
            !searchResult && selectedSection?.type && <Details contentData={selectedSection} />
          )}
          {searchResult && <SearchPage />}
        </div>
      </div>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  background: {
    padding: '10px 20px',
    background: theme.colors.gray01,
    color: theme.colors.gray75,
    paddingBottom: 100,
  },
  containerScalers: {
    margin: 'auto',
    position: 'relative',
    maxWidth: '80vw',
    minHeight: '100vh',
    [theme.breakpoints.down('md')]: {
      maxWidth: '95vw',
    },
  },

  contentWrapper: {
    display: 'flex',
  },
  verticalWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    flex: 3,
    minWidth: 0,
  },
}));

export default Instruction;
